<template>
  <ListingBlock
    class="new-releases"
    :view="view"
    :docs="view.docs().filteredDocs.slice(0, 3)"
  />
</template>

<script setup lang="ts">
import ListingBlock from '@/app/components/listing/ListingBlock.vue'

import type { ListView } from '@/models/docs.list'

defineProps<{
  view: ListView
}>()
</script>

<style lang="scss" scoped>
.new-releases {
  --listing-block-number-of-columns: 2;
  --listing-block-items-width-mobile: 312px;

  @media (min-width: $w-tablet-b) {
    &:deep(.releases-block__item:nth-child(3)) {
      display: none;
    }
  }
}
</style>
